export default __webpack_public_path__ + "static/media/scw-grid-6.81368d5d.svg";